import styled from "styled-components";

const CustomCheckBoxLabel = styled.div`
  display: flex;
  font-size: 2em;
  justify-content: space-between;
  min-height: 1.5em;
  padding-top: 1.2em;
`;

export default CustomCheckBoxLabel;
